// extracted by mini-css-extract-plugin
export default {"BackView":"index_BackView__8dRww","ic_back":"index_ic_back__J-nUb"};